// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form[data-v-1663c630] {\n  z-index: 201;\n}\n.form-card[data-v-1663c630] {\n  max-height: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
